import { isMarketOnline, type ConnectionType } from '@talos/kyoko';
import { useMemo } from 'react';
import { AvailabilityEnum, type AvailabilityCondition } from '../types';

/** A hook wrapper for getMarketOnlineCondition */
export const useMarketOnlineCondition = ({ connectionType }: GetMarketOnlineConditionParams): AvailabilityCondition => {
  return useMemo(() => getMarketOnlineCondition({ connectionType }), [connectionType]);
};

export interface GetMarketOnlineConditionParams {
  connectionType: ConnectionType;
}

/**
 * A AvailabilityCondition asserting that the Market.[ConnectionType] is present (defined) and that Market.[ConnectionType].Status
 * is Online
 * @deprecated - the backend API that produces the Online/Offline states we look at here are flaky. Do not use this condition. Leaving this here, but deprecated, so we don't
 * re-create it in the future. One day perhaps we can use this.
 */
export function getMarketOnlineCondition({ connectionType }: GetMarketOnlineConditionParams): AvailabilityCondition {
  return {
    id: 'marketOnline',
    ready: true,
    condition: market => {
      if (isMarketOnline(market, connectionType)) {
        return { availability: AvailabilityEnum.Ok };
      }
      return {
        availability: AvailabilityEnum.Disabled,
        render: () => `Market is not online for connection type ${connectionType}`,
      };
    },
  };
}
